var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"location"},[_c('p',[_vm._v("Ваш город:")]),_c('div',{on:{"click":_vm.showLocation}},[_c('span',[_vm._v(_vm._s(_vm.currentLocation.title))]),_c('ArrowDownBold')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }